import React, { useState } from 'react'
import { useIntl } from 'react-intl'

import UserCanAskUserAdminApprovalModal from '../user-can-ask-user-admin-approval-modal/UserCanAskUserAdminApprovalModal'
import {
  ClientProposalOutputDto,
  NonCompliantRulesFragment,
} from '../../../../../../../lib/graphql'
import { errorToast } from '../../../../../../../utils'
import { Icon } from '../../../../../../atoms'
import { NonCompliantLabel } from '../../../../../../molecules/non-compliant-rules/NonCompliantLabel'
import { IProposalInteractionsProps } from '../../../../Proposal'
import PingPongButton from '../../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../utils/ping-pong-button-type.enum.ts'

const UserCanAskUserAdminApprovalFooter = ({
  clientProposal,
  userActions,
}: {
  clientProposal: NonCompliantRulesFragment &
    Pick<ClientProposalOutputDto, '_id'>
  userActions: IProposalInteractionsProps['userActions']
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const intl = useIntl()
  const userAskedUserAdminApproval = userActions?.userAskedUserAdminApproval

  if (!userAskedUserAdminApproval) {
    return null
  }

  const onSubmit = async ({ comment }: { comment?: string }) => {
    try {
      await userAskedUserAdminApproval.callback({
        clientProposalId: clientProposal._id,
        comment,
      })
      setIsOpen(false)
    } catch {
      errorToast([
        intl.formatMessage({
          id: 'ui.UserCanAskUserAdminApprovalFooter.error',
          defaultMessage:
            "Impossible de demander l'approbation de l'administrateur",
        }),
      ])
    }
  }

  return (
    <div>
      <div className='flex w-full items-center gap-2 rounded-md bg-grey-300 p-2 text-xs text-grey-800'>
        <Icon size={24} name='info-outline' />
        <NonCompliantLabel clientProposal={clientProposal} />
      </div>
      <div className='flex w-full flex-col gap-3 py-5'>
        <PingPongButton
          dataTestId='book-this-stay-button'
          label={intl.formatMessage({
            id: 'ui.UserAskedUserAdminApprovalButton.bookThisStay',
            defaultMessage: 'Réserver ce séjour',
          })}
          type={PingPongButtonTypeEnum.CONFIRM}
          onClick={() => setIsOpen(true)}
        />
      </div>
      {isOpen && (
        <UserCanAskUserAdminApprovalModal
          closeModal={() => setIsOpen(false)}
          onSubmit={onSubmit}
          isOpen={isOpen}
          isLoading={userActions?.userAskedUserAdminApproval.isLoading}
        />
      )}
    </div>
  )
}

export default UserCanAskUserAdminApprovalFooter
